

export enum IDS {
  Id = "{id}",
  OptionalId = "{id?}",
  UserId = "{userId}"
}

export enum CONTROLLERS {
  ControllerLiteral = "[controller]",
  ActionItemAttachments = "actionitemattachments",
  Committees = "committees",
  CommitteeApplicationAttachments = "committeeapplicationattachments",
  Meetings = "meetings",
  MeetingTypes = "meetingtypes",
  MeetingAttachments = "meetingattachments",
  PublicNotices = "publicnotices",
  OpenPositions = "openpositions",
  TemporaryAttachments = "temporaryattachments"
}

export enum METHODS {
  ActionLiteral = "[action]",
  IdActionLiteral = "{id}/[action]",
  READ = "Read",
  CREATE = "Create",
  GetAddFromEFileEnvelope = "GetAddFromEFileEnvelope",
  GET = "Get",
  POST = "Post",
  PUT = "Put",
  DESTROY = "Destroy",
  UPDATE = "Update",
  ADDEDIT = "AddEdit",
  EXPORT = "Export",
  REORDER = "Reorder",
  DROPDOWN_ITEMS = "DropdownItems",
  Upload = "Upload",
  Download = "Download",
  DownloadSignaturePlaceholder = "DownloadSignaturePlaceholder",
  DownloadImagePlaceholder = "DownloadImagePlaceholder",
  Stream = "Stream",
  DeleteTempBlob = "DeleteTempBlob"
}

export enum URLS {
  Api = "publicportal/api",
  ApiPrefix = "publicportal/api/",
  ApiController = "publicportal/api/[controller]",
  Default = "publicportal/api/[controller]/[action]/{id?}",
  Validate = "validate",
  AddEdit = "AddEdit/{id?}",
  ActionIdLiteral = "[action]/{id}",
  ActionOptionalIdLiteral = "[action]/{id?}",
  IdActionLiteral = "{id}/[action]",
  ActionFilter = "[action]/{filter}",
  ActionItemAttachments = "publicportal/api/actionitemattachments",
  Committees = "publicportal/api/committees",
  CommitteeApplicationAttachments = "publicportal/api/committeeapplicationattachments",
  Meetings = "publicportal/api/meetings",
  MeetingTypes = "publicportal/api/meetingtypes",
  MeetingAttachments = "publicportal/api/meetingattachments",
  PublicNotices = "publicportal/api/publicnotices",
  OpenPositions = "publicportal/api/openpositions",
  TemporaryAttachments = "publicportal/api/temporaryattachments"
}

export class Endpoint {
  constructor(controller: string) {
    this.base = controller;
    this.read = this.controllerActionString(METHODS.READ);
    this.create = this.controllerActionString(METHODS.CREATE);
    this.destroy = this.controllerActionString(METHODS.DESTROY);
    this.update = this.controllerActionString(METHODS.UPDATE);
    this.get = this.controllerActionString(METHODS.GET);
    this.dropdownItems = this.controllerActionString(METHODS.DROPDOWN_ITEMS);
    this.put = this.controllerActionString(METHODS.PUT);
    this.post = this.controllerActionString(METHODS.POST);
    this.addedit = this.controllerActionString(METHODS.ADDEDIT);
  } 

  controllerActionString(method: string) {
    return `${this.base}/${method}`;
  }

  readonly base: string;
  readonly read: string;
  readonly create: string;
  readonly destroy: string;
  readonly update: string;
  readonly get: string;
  readonly dropdownItems: string;
  readonly post: string;
  readonly put: string;
  readonly addedit: string;
}

export const AgendaEndpoints = {
  actionitemattachments: new Endpoint(CONTROLLERS.ActionItemAttachments),
  committees: new Endpoint(CONTROLLERS.Committees),
  committeeapplicationattachments: new Endpoint(CONTROLLERS.CommitteeApplicationAttachments),
  meetings: new Endpoint(CONTROLLERS.Meetings),
  meetingtypes: new Endpoint(CONTROLLERS.MeetingTypes),
  meetingattachments: new Endpoint(CONTROLLERS.MeetingAttachments),
  publicnotices: new Endpoint(CONTROLLERS.PublicNotices),
  openpositions: new Endpoint(CONTROLLERS.OpenPositions),
  temporaryattachments: new Endpoint(CONTROLLERS.TemporaryAttachments)
};
